import {Component, Input} from '@angular/core';
import {Router} from '@angular/router';
import {NgClass} from '@angular/common';
import {AppNavigationHistoryService} from '../../../core/services/app-navigation-history.service';

@Component({
  selector: 'app-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss'],
  imports: [NgClass],

})
export class BackButtonComponent {
  @Input() variant: 'grey' | 'transparent' = 'grey';
  @Input() navigateTo?: string;

  constructor(
    private router: Router,
    private history: AppNavigationHistoryService
  ) {
  }

  goBack() {
    if (this.navigateTo) {
      this.router.navigate([this.navigateTo]);
      return;
    }

    if (this.history.canGoBack()) {
      const prev = this.history.previousUrl();
      this.history.popCurrent();
      if (prev) {
        this.router.navigateByUrl(prev);
        return;
      }
    }

    this.router.navigateByUrl('/');
  }
}
